export const BASE_URL = "https://movieshq.vercel.app";
export const USERS_URL = "/api/v1/users";
export const GENRE_URL = "/api/v1/genres";
export const MOVIE_URL = "/api/v1/movies";
export const UPLOAD_URL = "/api/v1/upload";
